import { render } from "./ProjectBenefitsAndRisks.vue?vue&type=template&id=7712999b"
import script from "./ProjectBenefitsAndRisks.vue?vue&type=script&lang=js"
export * from "./ProjectBenefitsAndRisks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__